/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Supplier API
 * Areeb Supplier REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CatalogItemResponseDto } from './CatalogItemResponseDto';
import {
    CatalogItemResponseDtoFromJSON,
    CatalogItemResponseDtoFromJSONTyped,
    CatalogItemResponseDtoToJSON,
} from './CatalogItemResponseDto';

/**
 * 
 * @export
 * @interface ProductCatalogResponseDto
 */
export interface ProductCatalogResponseDto {
    /**
     * Catalog ID
     * @type {number}
     * @memberof ProductCatalogResponseDto
     */
    id: number;
    /**
     * Organization ID this catalog belongs to
     * @type {number}
     * @memberof ProductCatalogResponseDto
     */
    organizationId: number;
    /**
     * Array of catalog items (products with supplier pricing)
     * @type {Array<CatalogItemResponseDto>}
     * @memberof ProductCatalogResponseDto
     */
    catalogItems: Array<CatalogItemResponseDto>;
    /**
     * Creation timestamp
     * @type {Date}
     * @memberof ProductCatalogResponseDto
     */
    createdAt: Date;
    /**
     * Last update timestamp
     * @type {Date}
     * @memberof ProductCatalogResponseDto
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the ProductCatalogResponseDto interface.
 */
export function instanceOfProductCatalogResponseDto(value: object): value is ProductCatalogResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('catalogItems' in value) || value['catalogItems'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function ProductCatalogResponseDtoFromJSON(json: any): ProductCatalogResponseDto {
    return ProductCatalogResponseDtoFromJSONTyped(json, false);
}

export function ProductCatalogResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductCatalogResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'organizationId': json['organizationId'],
        'catalogItems': ((json['catalogItems'] as Array<any>).map(CatalogItemResponseDtoFromJSON)),
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function ProductCatalogResponseDtoToJSON(value?: ProductCatalogResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'organizationId': value['organizationId'],
        'catalogItems': ((value['catalogItems'] as Array<any>).map(CatalogItemResponseDtoToJSON)),
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
    };
}

